// Cookies carry credentials. JavaScript only reads the non-secret CSRF cookie.
export const csrfToken = () => {
  const value = document.cookie.split('; ').find(item => item.startsWith('csrftoken='));
  return value ? decodeURIComponent(value.slice('csrftoken='.length)) : '';
};

let sessionBootstrap;
export const ensureBrowserSession = () => {
  if (!sessionBootstrap) {
    sessionBootstrap = (async () => {
      const seed = await fetch('/api/session/', { credentials: 'same-origin' });
      if (!seed.ok) throw new Error('No se pudo preparar la sesión.');
      // One-time upgrade. The old credential is revoked on successful migration.
      const legacy = localStorage.getItem('token') || localStorage.getItem('access_token');
      if (legacy) {
        const migrated = await fetch('/api/session/migrate/', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Authorization: `Token ${legacy}`, 'X-CSRFToken': csrfToken(), 'X-FOTH-Client': 'web' },
        });
        if (!migrated.ok && migrated.status !== 401) throw new Error('No se pudo migrar la sesión.');
        localStorage.removeItem('token');
        localStorage.removeItem('access_token');
      }
    })().catch(error => {
      sessionBootstrap = null;
      throw error;
    });
  }
  return sessionBootstrap;
};

export const prepareBrowserRequest = async config => {
  await ensureBrowserSession();
  config.withCredentials = true;
  config.headers = config.headers || {};
  delete config.headers.Authorization;
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  config.headers['X-FOTH-Client'] = 'web';
  config.headers['X-CSRFToken'] = csrfToken();
  return config;
};

export const browserFetch = async (input, options = {}) => {
  const url = new URL(input, window.location.origin);
  if (url.origin !== window.location.origin || !url.pathname.startsWith('/api/')) {
    throw new Error('La API debe utilizar el mismo origen que la aplicación.');
  }
  await ensureBrowserSession();
  const headers = new Headers(options.headers);
  headers.delete('Authorization');
  headers.set('X-FOTH-Client', 'web');
  headers.set('X-CSRFToken', csrfToken());
  return fetch(input, { ...options, headers, credentials: 'same-origin' });
};
